import {
  API_ERROR,
  SETTINGS_DATA,
  SETTINGS_DATA_SUCCESS,
  SETTINGS_SAVE,
  SETTINGS_SAVE_SUCCESS,
  SETTINGS_INPUT_CHANGEVALUE
} from "./actionTypes";

export const getSettings = () => {
  return {
    type: SETTINGS_DATA,
    payload: {  },
  };
};
export const getSettingsSuccessful = (response) => {
  return {
    type:  SETTINGS_DATA_SUCCESS,
    payload: response,
  };
};

export const SettingsSave = (data, history) => {
  return {
   type: SETTINGS_SAVE,
   payload: { data, history },
 };
};

export const SettingsSaveSuccessful = (response) => {
  return {
   type: SETTINGS_SAVE_SUCCESS,
   payload: response,
 };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};


export const SettingsInputChangeValue = ({ key, value }) => {
  return {
    type: SETTINGS_INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};